import React, { useState } from 'react';
import { Box, Input } from '@mui/material';
import { useL2DTheme } from '@europrocurement/flexy-components';
import { FlexyFilterValue, FlexyFilterWidgetProps } from '../DatatableHeader';

export const FlexyTextFilter: React.FunctionComponent = function (props: FlexyFilterWidgetProps) {
    const { filter, value, onChange } = props;
    const [localValue, setLocalValue] = useState<FlexyFilterValue | null>(value || '');
    const { palette } = useL2DTheme();

    const handleChange = (inputValue: string) => {
        setLocalValue(inputValue);
        onChange(inputValue);
    };

    return (
        <Box
            sx={{
                width: '100%',
                padding: '10px',
            }}
        >
            <Input
                type={filter.type}
                placeholder={filter.label}
                onChange={(e) => handleChange(e.target.value)}
                value={localValue}
                fullWidth
                disableUnderline
                inputProps={{
                    sx: {
                        color: palette.text.primary,
                        borderColor: palette.background.shadow,
                        height: '48px',
                        boxSizing: 'border-box',
                        padding: '8px 16px',
                        borderRadius: '12px',
                        fontSize: '16px',
                        fontWeight: '400',
                        lineHeight: '32px',
                        textAlign: 'left',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                    },
                }}
            />
        </Box>
    );
};
